import { Badge } from '@ui/components/Badge';

import { TournamentEntrance, TournamentMode, TournamentSystem } from '@features/shared/api/typings';
import { OPEN_WITH_PRE_MODERATION_ENTRANCE } from '@features/tournament/ui/components/TournamentSettings/utils';

const entrances: {
  [k in TournamentEntrance | typeof OPEN_WITH_PRE_MODERATION_ENTRANCE]: string;
} = {
  [OPEN_WITH_PRE_MODERATION_ENTRANCE]: 'Открытый\u00A0(модерация)',
  Open: 'Открытый',
  Rank: 'По\u00A0рейтингу',
  Invite: 'По\u00A0приглашению',
};

type Props = {
  tournament?: {
    system: TournamentSystem;
    mode: TournamentMode;
    entrance: TournamentEntrance;
    participantPreModerationEnabled: boolean;
  };
  isManager?: boolean;
};

export function TournamentEntranceBadge({ tournament, isManager }: Props) {
  if (!tournament) return null;
  if (tournament.system === 'Seance') return null;

  let entrance = entrances[tournament.entrance];
  if (isManager && tournament.participantPreModerationEnabled) {
    entrance = entrances[OPEN_WITH_PRE_MODERATION_ENTRANCE];
  }

  return (
    <Badge size="m" flat>
      {entrance}
    </Badge>
  );
}
